(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MembershipDetailController', MembershipDetailController);

    MembershipDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Membership', 'PromoCode'];

    function MembershipDetailController($scope, $rootScope, $stateParams, previousState, entity, Membership, PromoCode) {
        var vm = this;

        vm.membership = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:membershipUpdate', function(event, result) {
            vm.membership = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
